import classNames from 'classnames/bind';
import Icon, { IconVariant } from 'src/components/ui-kit/icon/icon';
import styles from './form.module.scss';
import { FormTextInputProps, getError } from './_text-input';
import FormError from './_error';

const classesContext = classNames.bind(styles);

export default function FormCheckbox<T>({
  children,
  className,
  formik,
  name,
  onChange,
  type,
  checked,
  ...inputProps
}: FormTextInputProps<T>): JSX.Element {
  const error = getError<T>(formik, name);

  return (
    <label className={classesContext(['checkbox_wrapper', className])}>
      <input
        onChange={formik?.handleChange ?? onChange}
        type='checkbox'
        name={name}
        checked={checked}
        {...inputProps}
      />
      <span className={classesContext(['checkbox', { checkbox__error: error }])}>
        <span className={styles.checkbox_icon}>
          <Icon variant={IconVariant.CHECKBOX} />
        </span>
      </span>
      {children}
      {error && <FormError error={error} />}
    </label>
  );
}
